// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"167":"detail","177":"home"}[chunkId] || chunkId) + "." + {"8":"760fb7ce","167":"f5c8d781","177":"4434ec76","191":"b97245db","279":"73ca32cc","297":"ba85d166","511":"ca86f368","513":"7e6f2c32","906":"b0bf64de"}[chunkId] + ".js";
};